/**
 * Admin in the kit's staff sign-in screens (BM-44: they live in `@bemor/web-kit/staff-auth`, shared with
 * ledger-admin). The provider config names the app in the copy; `errorCopy` is the kit's with that name.
 */
import {
    errorCopy as kitErrorCopy,
    type AuthError,
    type StaffAuthConfig,
} from '@bemor/web-kit/staff-auth';

export const STAFF_AUTH: StaffAuthConfig = {
    product: 'Admin',
    audience: 'Bemor staff, with your company Google account.',
};

export const errorCopy = (error: AuthError): string =>
    kitErrorCopy(error, STAFF_AUTH.product);
